const addGTMEvent = (event: string, props: Object ) => {
  // @ts-ignore
  if(window.dataLayer) window.dataLayer.push({ event, ...props });
};

export default addGTMEvent;
